var render = function render(){
  var _vm$error, _vm$error$validationM, _vm$error2, _vm$error2$validation, _vm$error3, _vm$error3$validation, _vm$formData$chatbotT;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('profile.header')))]), _vm.error && _vm.error.key ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.error.key)) + " ")]) : _vm._e(), _c('b-form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "profile-first-name",
      "required": "",
      "label": _vm.$t('profile.form.first-name'),
      "state": _vm.getState('firstName'),
      "validation-messages": (_vm$error = _vm.error) === null || _vm$error === void 0 ? void 0 : (_vm$error$validationM = _vm$error.validationMessages) === null || _vm$error$validationM === void 0 ? void 0 : _vm$error$validationM.firstName,
      "type": "text"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.firstName.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('profile.form.first-name')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.firstName.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('profile.form.first-name'),
          max: _vm.$v.formData.firstName.$params.maxLength.max
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formData.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "firstName", $$v);
      },
      expression: "formData.firstName"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "profile-last-name",
      "label": _vm.$t('profile.form.last-name'),
      "required": "",
      "state": _vm.getState('lastName'),
      "validation-messages": (_vm$error2 = _vm.error) === null || _vm$error2 === void 0 ? void 0 : (_vm$error2$validation = _vm$error2.validationMessages) === null || _vm$error2$validation === void 0 ? void 0 : _vm$error2$validation.lastName,
      "type": "text"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.lastName.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('profile.form.last-name')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.lastName.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('profile.form.last-name'),
          max: _vm.$v.formData.lastName.$params.maxLength.max
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formData.lastName,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "lastName", $$v);
      },
      expression: "formData.lastName"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "profile-email",
      "label": _vm.$t('profile.form.email'),
      "type": "email",
      "disabled": ""
    },
    model: {
      value: _vm.formData.email,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "email", $$v);
      },
      expression: "formData.email"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "profile-phone",
      "required": "",
      "label": _vm.$t('profile.form.phone'),
      "state": _vm.getState('phone'),
      "validation-messages": (_vm$error3 = _vm.error) === null || _vm$error3 === void 0 ? void 0 : (_vm$error3$validation = _vm$error3.validationMessages) === null || _vm$error3$validation === void 0 ? void 0 : _vm$error3$validation.phone,
      "type": "text"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.phone.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('profile.form.phone')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.phone.minLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.min-length', {
          field: _vm.$t('profile.form.phone'),
          min: _vm.$v.formData.phone.$params.minLength.min
        })) + " ")]) : _vm._e(), !_vm.$v.formData.phone.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('profile.form.phone'),
          max: _vm.$v.formData.phone.$params.maxLength.max
        })) + " ")]) : _vm._e(), !_vm.$v.formData.phone.phoneNumber ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.phone')) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formData.phone,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "phone", $$v);
      },
      expression: "formData.phone"
    }
  })], 1), _vm.showChatbotQuotaFields ? _c('b-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "profile-chatbot-token-limit-group",
      "label": _vm.$t('admin.field.chatbot-token-limit'),
      "label-for": "profile-chatbot-token-limit-field"
    }
  }, [_c('b-form-input', {
    staticClass: "form-input",
    attrs: {
      "id": "profile-chatbot-token-limit-field",
      "type": "text",
      "inputmode": "numeric",
      "pattern": "[0-9]*",
      "disabled": !_vm.isFormChatbotEnabled,
      "state": _vm.chatbotTokenLimitState
    },
    on: {
      "keydown": _vm.onChatbotTokenLimitKeydown,
      "paste": function ($event) {
        $event.preventDefault();
        return _vm.onChatbotTokenLimitPaste.apply(null, arguments);
      },
      "drop": function ($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: _vm.chatbotTokenLimitInput,
      callback: function ($$v) {
        _vm.chatbotTokenLimitInput = $$v;
      },
      expression: "chatbotTokenLimitInput"
    }
  }), _vm.isChatbotTokenLimitRequiredInvalid ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
    field: _vm.$t('admin.field.chatbot-token-limit')
  })) + " ")]) : _vm._e(), _vm.isChatbotTokenLimitIntegerInvalid ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.chatbot-token-limit.integer')) + " ")]) : _vm._e(), _vm.isChatbotTokenLimitMinInvalid ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.chatbot-token-limit.min')) + " ")]) : _vm._e(), _vm.isChatbotTokenLimitMaxInvalid ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.chatbot-token-limit.max', {
    max: _vm.chatbotTokenLimitMax
  })) + " ")]) : _vm._e(), _vm.isChatbotTokenLimitUsedMinInvalid ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.chatbot-token-limit.used-min', {
    used: _vm.chatbotTokensUsedMonthly
  })) + " ")]) : _vm._e(), _vm._l(_vm.chatbotTokenLimitBackendValidationMessages, function (message, index) {
    return _c('b-form-invalid-feedback', {
      key: `chatbot-token-limit-validation-${index}`
    }, [_vm._v(" " + _vm._s(message) + " ")]);
  })], 2)], 1) : _vm._e(), _vm.showChatbotQuotaFields ? _c('b-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "profile-chatbot-tokens-used-group",
      "label": _vm.$t('admin.field.chatbot-tokens-used'),
      "label-for": "profile-chatbot-tokens-used-field"
    }
  }, [_c('b-form-input', {
    staticClass: "form-input",
    attrs: {
      "id": "profile-chatbot-tokens-used-field",
      "value": String((_vm$formData$chatbotT = _vm.formData.chatbotTokensUsedMonthly) !== null && _vm$formData$chatbotT !== void 0 ? _vm$formData$chatbotT : 0),
      "disabled": ""
    }
  })], 1)], 1) : _vm._e(), _vm.showChatbotQuotaFields ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "profile-chatbot-enabled-group",
      "label": _vm.$t('admin.field.chatbot-enabled'),
      "label-for": "profile-chatbot-enabled-field"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "profile-chatbot-enabled-field",
      "switch": "",
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.formData.chatbotEnabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "chatbotEnabled", $$v);
      },
      expression: "formData.chatbotEnabled"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.chatbotEnabled ? _vm.$t('admin.field.chatbot-on') : _vm.$t('admin.field.chatbot-off')) + " ")])], 1)], 1) : _vm._e()], 1), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "auto",
      "sm": "12"
    }
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.isFormDataSameAsInitialData
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profile.button.submit')) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }